import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { setShowSwitchUserTypeModal } from "app/store/manualUpload/slice/manualUploadSlice";

const SwitchPatientTypeModal = ({ handlePatientTypeSwitch }) => {
  const { isExistingPatient, showSwitchUserTypeModal } = useSelector(
    (state) => state.manualUpload
  );

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setShowSwitchUserTypeModal(false));
  };

  return (
    <div>
      <ModalWrapper
        show={showSwitchUserTypeModal}
        showTitle={true}
        maxWidth="xs"
        showCloseIcon={true}
        headerStyle={{ padding: "4px 24px" }}
        onClose={onClose}
        title={`Switch to ${
          isExistingPatient ? "New Patient" : "Existing Patient"
        }`}
        children={
          <p
            style={{ fontSize: "14px" }}
            data-label="switch-patient-type-confirmation-message"
          >
            Your changes to the form will not be saved. Are you sure you want to
            switch to {isExistingPatient ? "New Patient" : "Existing Patient"}?
          </p>
        }
        actionButtons={[
          {
            label: "Continue Editing",
            variant: "outlined",
            onClick: onClose,
            dataAction: "switch-patient-type-continue-editing-button",
          },
          {
            label: "Yes, Switch",
            variant: "contained",
            color: "secondary",
            onClick: handlePatientTypeSwitch,
            dataAction: "switch-patient-type-yes-switch-button",
          },
        ]}
      ></ModalWrapper>
    </div>
  );
};

export default SwitchPatientTypeModal;
